import { render, staticRenderFns } from "./PackageContactsModal.vue?vue&type=template&id=5a038232&scoped=true&"
import script from "./PackageContactsModal.vue?vue&type=script&lang=js&"
export * from "./PackageContactsModal.vue?vue&type=script&lang=js&"
import style0 from "./PackageContactsModal.vue?vue&type=style&index=0&id=5a038232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a038232",
  null
  
)

export default component.exports